import React, { useState, useEffect } from 'react';
import Title from '../../../components/Title';
import '../../../font.css';
import '../../../index.css';
import { useLocation } from 'react-router-dom';
import {
  addPublishedContents,
  updatePublishedContents,
  getMobileShopEnabled,
} from '../../../modules/NetworkFunction';
import { getPublishStyleKr } from '../../../utils/publishStyle';
import styled from 'styled-components';
import { useContext } from 'react';
import DesignPreviewPage from '../Preview/DesignPreViewPage';
import Modal from '../../Modal';
import AuthContext from '../../../contexts/AuthContext';
import icArrowDown from '../../../icons/ic-arrow-down.png';
import icDelete from '../../../icons/ic-delete-orange.png';
import radius0 from '../../../icons/ic-radius0-default.png';
import radius0Check from '../../../icons/ic-radius0-checked.png';
import radius10 from '../../../icons/ic-radius10-default.png';
import radius10Check from '../../../icons/ic-radius10-checked.png';
import radius50 from '../../../icons/ic-radius50-default.png';
import radius50Check from '../../../icons/ic-radius50-checked.png';
import { SketchPicker } from 'react-color';
import SetContentsModal from './SetContentsModal';
import ShopModeContext from '../../../contexts/ShopModeContext';
import infoIcon from '../../../icons/ic-paymentAgreement-info.png';
import{getUserDetail, getInicisPayment}  from '../../../modules/NetworkFunction';

const FONT_STYLES = ['심플한', '힙한', '감성적인', '세리프', '발랄한'];
const FONT_FAMILIES = {
  심플한: ['Noto Sans', 'Gmarket Sans'],
  힙한: ['HSJiptokki', 'BM HANNA 11yrs old'],
  감성적인: ['Chosun Centennial', 'Cafe24 Oneprettynight'],
  세리프: ['Cafe24 ClassicType', 'Cafe24 Danjunghae'],
  발랄한: ['BM JUA', 'Cafe24 Syongsyong'],
};
const FONT_FAMILIES_CODE = {
  'Noto Sans': 'Noto Sans KR',
  'Gmarket Sans': 'GmarketSansMedium',
  HSJiptokki: 'HSJiptokki-Black',
  'BM HANNA 11yrs old': 'Hanna',
  'Chosun Centennial': 'ChosunCentennial',
  'Cafe24 Oneprettynight': 'Cafe24Oneprettynight',
  'Cafe24 ClassicType': 'Cafe24ClassicType-Regular',
  'Cafe24 Danjunghae': 'Cafe24Danjunghae',
  'BM JUA': 'BMJUA',
  'Cafe24 Syongsyong': 'Cafe24Syongsyong',
};
const BUTTON_RADIUS = [
  {
    label: '날카로운(0%)',
    image: {
      default: radius0,
      selected: radius0Check,
    },
  },
  {
    label: '살짝 둥근(10%)',
    image: {
      default: radius10,
      selected: radius10Check,
    },
  },
  {
    label: '아주 둥근(50%)',
    image: {
      default: radius50,
      selected: radius50Check,
    },
  },
];

function ContentDesignManagement({ history }) {
  const location = useLocation();
  const {
    isPaid,
    publishedContents,
    user,
    isModify,
    contentsNo,
    shopVersion,
    style,
  } = location.state;
  console.log(ContentDesignManagement, location.state);

  const { shopMode } = useContext(ShopModeContext);

  const shopURL = isModify
    ? location.state.shopURL
    : shopMode === 'makeshop'
    ? user.makeshopURL
    : user.cafe24URL.substr(-1) === '/'
    ? user.cafe24URL.slice(0, -1)
    : user.cafe24URL;

  const [detailPagePath, setDetailPagePath] = useState(location.state.detailPagePath || '');

  useEffect(() => {
    if (location.state?.detailPagePath) {
      setDetailPagePath(location.state.detailPagePath);
    }
  }, [location.state?.detailPagePath]);
  
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [selectedFont, setSelectedFont] = React.useState();
  const [selectedFontFamily, setSelectedFontFamily] = React.useState();
  const [selectedRadiusIdx, setSelectedRadiusIdx] = useState(-1);
  const [modalOpen, setModalOpen] = useState(false);
  const [publishedContentNo, setPublishedContentNo] = useState(
    location.state.publishedContentNo
  );
  const [isInicisPaid, setIsInicisPaid] = useState(false);
  const { auth: token } = useContext(AuthContext);
  const [userData, setUserData] = useState();
  console.log('shopMode', shopMode==="cafe24");
  
  // 폰트 선택
  const onClickFontButton = (index) => {
    setSelectedFont(index);
  };

  // 버튼 컬러 지정
  const [btnColor, setBtnColor] = useState('#000000');
  const onButtonColorChange = (e) => {
    setBtnColor(e.hex);
  };

  // 폰트 컬러 지정
  const [fontColor, setFontColor] = useState('#ffffff');
  const onFontColorChange = (e) => {
    setFontColor(e.hex);
  };

  //margin 설정
  const [margin, setMargin] = useState();
  const handleMarginChange = (e) => {
    const value = e.target.value;
    setMargin(value);
  };

  const [useMobileShop, setUseMobileShop] = useState(false);
  const [hash, setHash] = useState();

  const requestBody = {
    shopNo: Number(window.localStorage.getItem('shopNo')),
    mallId: window.localStorage.getItem('mallId'),
    token: window.sessionStorage.getItem('accessToken'),
  };

  useEffect(() => {
    getMobileShopEnabled(
      requestBody,
      (v) => {
        setUseMobileShop(v);
      },
      (e) => {
        console.log('getMobileShopEnabled error');
      },
      token
    );
  }, []);

  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    history.push({
      pathname: '/mypage/contents-posting-management',
    });
  };

  const closePreviewModal = () => {
    setIsPreviewModalOpen(false);
  };

  const openPreviewModal = () => {
    setIsPreviewModalOpen(true);
  };

  const publishContent = () => {
    if (selectedFontFamily === undefined) {
      alert('폰트를 선택해주세요.');
      return;
    } else if ((shopMode ==='cafe24'? isPaid:isInicisPaid) && selectedRadiusIdx === -1) {
      alert('버튼 곡률을 선택해주세요.');
      return;
    } else if (margin > 100 || margin < 0) {
      if (!style.includes('popup')) {
        alert('마진을 0~100 사이의 수치로 입력해주세요.');
      }
      return;
    }
    console.log('publishContents: ', publishedContents);
    const isUpdateContents = publishedContents?.some(
      (content) => content.mobileYn === (shopVersion === 'mobile' ? 1 : 0)
    );
    if (isModify || isUpdateContents) {
      console.log('updatePublishedContents');
      console.log('fontColor', fontColor);
      console.log('btnColor', btnColor);
      updatePublishedContents(
        {
          publishedContentNo,
          shopURL,
          btnColor,
          fontColor,
          contentsNo,
          style,
          margin,
          mobileYn: shopVersion === 'mobile' ? 1 : 0,
          borderRadius:
            selectedRadiusIdx === 0 ? 0 : selectedRadiusIdx === 1 ? 10 : 50,
          font: FONT_FAMILIES_CODE[selectedFontFamily],
          useMobileShop: useMobileShop ? 1 : 0,
          detailPath: detailPagePath
        },
        (updatedData) => {
          setHash(updatedData.hash);
        },
        (e) => {
          console.log(e);
        },
        token
      );

      if (!isModify) {
        openModal();
      } else {
        history.push({
          pathname: '/mypage/contents-posting-management',
        });
      }
    } else {
      addPublishedContents(
        {
          shopURL,
          btnColor,
          fontColor,
          contentsNo,
          style,
          margin,
          mobileYn: shopVersion === 'mobile' ? 1 : 0,
          borderRadius:
            selectedRadiusIdx === 0 ? 0 : selectedRadiusIdx === 1 ? 10 : 50,
          font: FONT_FAMILIES_CODE[selectedFontFamily],
          useMobileShop: useMobileShop ? 1 : 0,
          detailPath: detailPagePath,
          shop: shopMode,
        },
        (data) => {
          console.log(data);
          setHash(data);
        },
        (e) => {
          console.log(e);
        },

        token
      );
      openModal();
    }
  };

  useEffect(() => {
    getUserDetail(
      null,
      (v) => {
        setUserData(v.user);
      },
      () => {},
      (e) => {
        console.log('getuserdetail', e);
      },
      token
    );
  }, [token]);

  useEffect(() => {
    getInicisPayment(
      {
        userNo: userData?.userNo
      },
      (v) => {
        console.log(v);
        if (v.payment.length > 0){
          setIsInicisPaid(true)
        } else {
          setIsInicisPaid(false)
        }
      },
      () => {},
      (error) => {
        console.error(error);
      },
      token
    )

  }, [userData, token])

  return (
    <div style={{ paddingBottom: 40, position: 'relative' }}>
      {/* 미리보기 페이지 모달 */}
      <Modal open={isPreviewModalOpen}>
        <DesignPreviewPage
          closeModal={closePreviewModal}
          contentsNo={contentsNo}
          contentStyle={getPublishStyleKr(style)}
          shopVersion={shopVersion}
          publishedContents={publishedContents}
          selectedFontFamily={selectedFontFamily}
          onSelectSelectedFontFamily={setSelectedFontFamily}
          selectedfontStyle={selectedFont}
          onSelectSelectedFontStyle={setSelectedFont}
          margin={margin}
          onSelectMargin={setMargin}
          selectedRadiusIdx={selectedRadiusIdx}
          onSelectSelectedRadiusIdx={setSelectedRadiusIdx}
          fontColor={fontColor}
          onSelectFontColor={setFontColor}
          btnColor={btnColor}
          onSelectBtnColor={setBtnColor}
          isPaid={(shopMode==="cafe24"? isPaid:isInicisPaid)}
        />
      </Modal>
      <InfoText>* 해당 설정은 구매하기 버튼과 now 버튼에 적용됩니다.</InfoText>
      <Title title="디자인 테마" />
      <div className="inner-box" style={{ marginBottom: 45 }}>
        <p className="subtitle">폰트 스타일 선택</p>
        <ButtonContainer>
          {FONT_STYLES.map((fontStyle, index) => {
            return (
              <Button
                selected={selectedFont === index}
                key={fontStyle}
                onClick={() => onClickFontButton(index)}
                type={'button'}
              >
                {' '}
                {fontStyle}
              </Button>
            );
          })}
        </ButtonContainer>
      </div>
      <div style={{ marginBottom: 75, display: 'flex', gap: '10px' }}>
        <div style={{ width: !style.includes('popup') ? '100%' : '50%' }}>
          <p className="subtitle">폰트 선택</p>
          <Select
            onChange={(e) => {
              setSelectedFontFamily(e.target.value);
            }}
          >
            <option value="" hidden>
              폰트 스타일을 선택해주세요
            </option>
            {(selectedFont !== undefined ? FONT_STYLES : []).map(
              (fontStyle, index) => (
                <option
                  selected={selectedFont === index}
                  key={fontStyle}
                  value=""
                  hidden
                >
                  {fontStyle + ' 스타일 폰트 목록' || '제목 없음'}
                </option>
              )
            )}
            {(selectedFont !== undefined
              ? FONT_FAMILIES[FONT_STYLES[selectedFont]]
              : []
            ).map((item, idx) => (
              <option key={idx} value={item}>
                {item || '제목 없음'}
              </option>
            ))}
          </Select>
          {selectedFontFamily && (
            <FontPreview
              style={{ fontFamily: FONT_FAMILIES_CODE[selectedFontFamily] }}
            >
              {selectedFontFamily}
              <DeleteBtn
                onClick={() => {
                  setSelectedFontFamily();
                  setSelectedFont();
                }}
              ></DeleteBtn>
            </FontPreview>
          )}
        </div>
        {!style.includes('popup') && (
          <div style={{ width: '100%' }}>
            <p className="subtitle">마진 선택</p>
            <div style={{ display: 'flex', gap: '11px', alignItems: 'center' }}>
              <Input
                placeholder="수치를 직접 입력해주세요."
                value={margin}
                onChange={handleMarginChange}
              ></Input>
              <div
                style={{
                  color: '#848484',
                  fontFamily: 'Noto Sans',
                  fontSize: '20px',
                  fontWeight: '400',
                }}
              >
                px
              </div>
            </div>
            {margin > 100 && (
              <AlertBox>
                <img
                  src={infoIcon}
                  style={{
                    display: 'block',
                    width: '28px',
                    height: '28px',
                  }}
                  alt="AlertInfo"
                ></img>
                <AlertBoxText>최대 100까지 입력가능합니다.</AlertBoxText>
              </AlertBox>
            )}
          </div>
        )}
      </div>

      {(shopMode ==='cafe24'? isPaid:isInicisPaid) && (
        <div className="inner-box" style={{ marginBottom: 45 }}>
          <div
            style={{
              marginTop: 40,
              display: 'flex',
              flexDirection: 'row',
              gap: 100,
            }}
          >
            <ColorPickerContainer>
              <p className="subtitle">폰트 컬러 선택</p>
              <ColorPickerHeader>
                <ColorPreview backgroundColor={fontColor} />
                <ColorInput
                  type="text"
                  maxLength="7"
                  value={fontColor}
                  readOnly
                />
              </ColorPickerHeader>
              <SketchPicker
                color={fontColor}
                disableAlpha={true}
                onChange={onFontColorChange}
              />
            </ColorPickerContainer>
            <ColorPickerContainer>
              <p className="subtitle">버튼 컬러 선택</p>
              <ColorPickerHeader>
                <ColorPreview backgroundColor={btnColor} />
                <ColorInput
                  type="text"
                  maxLength="7"
                  value={btnColor}
                  readOnly
                />
              </ColorPickerHeader>
              <SketchPicker
                color={btnColor}
                disableAlpha={true}
                onChange={onButtonColorChange}
              />
            </ColorPickerContainer>
          </div>
        </div>
      )}
      {(shopMode ==='cafe24'? isPaid:isInicisPaid) && (
        <div className="inner-box" style={{ marginBottom: 45 }}>
          <p className="subtitle">버튼 곡률 선택</p>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                marginTop: 15,
              }}
            >
              {BUTTON_RADIUS.map((button, idx) => {
                return (
                  <RadiusButton
                    key={button.label}
                    onClick={() => setSelectedRadiusIdx(idx)}
                  >
                    <img
                      src={
                        selectedRadiusIdx === idx
                          ? button.image.selected
                          : button.image.default
                      }
                      alt={button.label}
                    />
                    {button.label}
                  </RadiusButton>
                );
              })}
            </div>
          </div>
        </div>
      )}
      <ButtonContainer align="true">
        <RoundButton
          backgroundColor={'#CCCCCC'}
          color={'#4D4D4D'}
          disable={false}
          onClick={openPreviewModal}
        >
          {'미리보기'}
        </RoundButton>
        <RoundButton
          backgroundColor={'#FFB600'}
          color={'#FFF'}
          disable={
            (shopMode ==='cafe24'? isPaid:isInicisPaid)
              ? !(
                  selectedFontFamily &&
                  fontColor &&
                  selectedRadiusIdx !== -1 &&
                  margin <= 100
                )
              : !(selectedFontFamily && margin <= 100)
          }
          onClick={publishContent}
        >
          {isModify ? '수정하기' : '게시하기'}
        </RoundButton>
      </ButtonContainer>
      <SetContentsModal
        open={modalOpen}
        close={closeModal}
        version={shopVersion}
        contentsNo={contentsNo}
        hash={hash}
      ></SetContentsModal>
    </div>
  );
}

export default ContentDesignManagement;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: ${({ align }) => (align ? 'flex-end' : 'flex-start')};
`;

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 93px;
  padding: 7px 0;
  border-radius: 5px;
  color: ${({ selected }) => (selected ? '#ffffff' : '#B5B5B5')};
  background-color: ${({ selected }) => (selected ? 'orange' : 'white')};
  font-size: 16px;
  box-shadow: ${({ selected }) =>
    selected ? 'none' : '0 0 0 1px #B5B5B5 inset'};
  cursor: pointer;
  border-width: 0;
`;

const Select = styled.select`
  width: 100%;
  margin: 0px;
  min-width: 0;
  display: block;
  padding: 8px 8px;
  font-size: 20px;
  line-height: inherit;
  border: 1px solid;
  border-radius: 5px;
  color: #c4c4c4;
  background-color: transparent;
  border-color: #c4c4c4;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  background-image: url(${icArrowDown});
  background-repeat: no-repeat;
  background-position: calc(100% - 10px) center;
`;

const ColorPickerContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ColorPickerHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0px;
  margin-bottom: 10px;
`;

const ColorPreview = styled.div`
  display: inline-block;
  margin: 0px;
  width: 50px;
  height: 25px;
  border-radius: 0px;
  background-color: ${(props) => props.backgroundColor};
  border: 0.5px #000000 solid;
`;

const ColorInput = styled.input`
  width: 100px;
  height: 25px;
  font-size: 16px;
  border-radius: 0px !important;
  border: 0.5px #c4c4c4 solid !important;
  outline: none;
`;

const FontPreview = styled.div`
  display: flex;
  margin-top: 10px;
  padding: 6px 13px;
  width: fit-content;
  height: fit-content;
  align-items: center;
  font-size: 16px;
  color: #ff7a00;
  background-color: #fff0db;
  border-radius: 3px;
  border: 0.5px #d0d0d0 solid;
`;

const DeleteBtn = styled.button`
  align-items: center;
  width: 26px;
  height: 26px;
  margin-left: 15px;
  background-image: url(${icDelete});
  background-repeat: no-repeat;
  background-size: cover;
  border-width: 0;
  outline: none;
  cursor: pointer;
`;

const RadiusButton = styled.div`
  display: flex;
  flex-direction: column;
  width: 110px;
  height: 110px;
  margin-right: 33px;
  color: #b5b5b5;
  font-size: 16px;
  cursor: pointer;
`;

const RoundButton = styled.div`
  display: flex;
  height: 40px;
  padding: 10px 30px;
  text-align: center;
  border-radius: 20px;
  font-size: 20px;
  font-weight: 700;
  border-width: 0;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.color};
  cursor: pointer;
  align-items: center;
`;

const InfoText = styled.div`
  position: absolute;
  top: 40px;
  right: 0;
  color: #ffb600;
  font-size: 12px;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  margin: 0px;
  min-width: 0;
  display: block;
  padding: 8px 8px;
  font-size: 20px;
  line-height: inherit;
  border: 1px solid;
  border-radius: 5px;
  color: #c4c4c4;
  background-color: transparent;
  border-color: #c4c4c4;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  background-repeat: no-repeat;
  background-position: calc(100% - 10px) center;

  &::placeholder {
    color: #c4c4c4;
    font-family: 'Noto Sans';
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

const AlertBox = styled.div`
  display: flex;
  box-sizing: border-box;
  gap: 5px;
  width: 230px;
  padding: 4px 10px;
  border-radius: 5px;
  background: rgba(255, 182, 0, 0.2);
  margin-top: 11px;
  align-items: center;
`;

const AlertBoxText = styled.div`
  color: #6e6e6e;
  font-family: 'Noto Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
